import { toast } from 'react-hot-toast';

import { ZepQuizApiError } from '@/api/httpClient';
import { type NamespacedTranslationKey } from '@/types/translation';

// 서버(zep-quiz-spring-server) commit 98045d36 에서 신설한 ErrorCode.
// 잠긴(유료 플랜 필요) 퀴즈셋을 학급에 연결하려고 할 때 4xx 와 함께 반환.
const CLASSROOM_LINK_ERROR_CODE = {
  QUIZSET_LOCKED: 'CLASS_LINK_QUIZSET_LOCKED',
} as const;

// 값 타입을 NamespacedTranslationKey 로 고정 → 시트에서 키가 사라지면 tsc 가 잡는다.
const ERROR_MESSAGE_KEYS: Record<string, NamespacedTranslationKey> = {
  [CLASSROOM_LINK_ERROR_CODE.QUIZSET_LOCKED]:
    'common:classroomLink.error.quizsetLocked',
};

export function handleClassroomLinkError(
  error: unknown,
  translate: (key: NamespacedTranslationKey) => string,
): boolean {
  if (!(error instanceof ZepQuizApiError)) return false;

  const key = ERROR_MESSAGE_KEYS[error.status];
  if (!key) return false;

  toast.error(translate(key));
  return true;
}
